import {Component, Input} from '@angular/core';
import {QuickLinksService} from "@tva/ng-migration/core/components/header/quick-links/quick-links.service";

@Component({
    providers: [QuickLinksService],
    selector: 'app-quick-links',
    templateUrl: './quick-links.component.html',
    styleUrls: ['./quick-links.component.scss']
})
export class QuickLinksComponent {
 	@Input() pfUrl: string;
    @Input() tvSchoolUrl: string;
    @Input() tvEnrollmentUrl: string;
    @Input() showTvEnrollment: boolean;
     @Input() showpf: boolean;


    constructor(private service: QuickLinksService) {
    }

    ssoLogin(url: string): void {
        console.log('CLICKS', url);
        this.service.ssoLogin().subscribe(newKeycode => {
            window.open(
                url.concat(newKeycode),
                "_blank"
            );
        });
    }

}
